var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ds-week"},[_vm._l((_vm.days),function(day,i){return [_c('ds-day',_vm._g(_vm._b({key:i,attrs:{"day":day,"calendar":_vm.calendar,"placeholder":_vm.placeholder,"placeholder-for-create":_vm.placeholderForCreate}},'ds-day',{ $scopedSlots: _vm.$scopedSlots },false),_vm.$listeners))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }